import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import { CreateAcquisitionForm } from "../Forms";

interface CreateAcquisitionModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onCancel: () => void;
  caseInfo?: { case_id: number };
  evidenceInfo?: { evidence_id: number; case_id?: number };
}

export const CreateAcquisitionModal: FC<CreateAcquisitionModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  caseInfo,
  evidenceInfo,
}) => {
  const handleSubmit = () => {
    onSubmit?.();
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  return (
    <>
      <Modal open={show} onClose={onClose}>
        <CreateAcquisitionForm
          width={650}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          caseInfo={caseInfo}
          evidenceInfo={evidenceInfo}
        />
      </Modal>
    </>
  );
};
